import { lazy } from 'react';
// Import Enums
import { ComparisonUITypeEnum } from 'enums';

const DynamicSegmentForms = {
    [ComparisonUITypeEnum.Text]: {
        Component: lazy(() => import('./SingleSimpleInputForm')),
        config: {},
    },
    [ComparisonUITypeEnum.DropDown]: {
        Component: lazy(() => import('./SingleSelectForm')),
        config: {},
    },
    [ComparisonUITypeEnum.Date]: {
        Component: lazy(() => import('./StaticAndDynamicDateSimpleTypeForm')),
        config: { withTimeConsider: false },
    },
    [ComparisonUITypeEnum.DateWithin]: {
        Component: lazy(() => import('./StaticAndDynamicDateFromToTypeForm')),
        config: { withTimeConsider: false },
    },
    [ComparisonUITypeEnum.Number]: {
        Component: lazy(() => import('./NumberSimpleInputWithHeadlineForm')),
        config: {},
    },
    [ComparisonUITypeEnum.NumberWithin]: {
        Component: lazy(() => import('./NumberFromToInputWithHeadlineForm')),
        config: {},
    },
    [ComparisonUITypeEnum.RadioButtonBox]: {
        Component: lazy(() => import('./SimpleConditionalForm')),
        config: {},
    },
    [ComparisonUITypeEnum.Currency]: {
        Component: lazy(() => import('./LossAmountSportsBookForm')),
        config: {},
    },
    [ComparisonUITypeEnum.CurrencyWithin]: {
        Component: lazy(() => import('./AverageWithdrawalForm')),
        config: {},
    },
    [ComparisonUITypeEnum.MonthDay]: {
        Component: lazy(() => import('./MonthDayPickerForm')),
        config: {},
    },
    [ComparisonUITypeEnum.MonthDayWithin]: {
        Component: lazy(() => import('./MonthDayPickerFromToForm')),
        config: {},
    },
    [ComparisonUITypeEnum.MultiSelect]: {
        Component: lazy(() => import('./MultiSelectForm')),
        config: {},
    },
    [ComparisonUITypeEnum.TreeViewWithCascadingDropdown]: {
        Component: lazy(() => import('./CascadeForm')),
        config: {},
    },
    [ComparisonUITypeEnum.CascadeDataMultiCall]: {
        Component: lazy(() => import('./CascadeForm')),
        config: {},
    },
    [ComparisonUITypeEnum.DateTime]: {
        Component: lazy(() => import('./StaticAndDynamicDateSimpleTypeForm')),
        config: { withTimeConsider: true },
    },
    [ComparisonUITypeEnum.DateTimeWithin]: {
        Component: lazy(() => import('./StaticAndDynamicDateFromToTypeForm')),
        config: { withTimeConsider: true },
    },
    [ComparisonUITypeEnum.FourStepsCascadeData]: {
        Component: lazy(() => import('./CascadeForm')),
        config: {},
    },
    [ComparisonUITypeEnum.FiveStepsCascadeData]: {
        Component: lazy(() => import('./CascadeForm')),
        config: {},
    },
    [ComparisonUITypeEnum.Percentage]: {
        Component: lazy(() => import('./PercentageForm')),
        config: {},
    },
    [ComparisonUITypeEnum.PercentageWithin]: {
        Component: lazy(() => import('./PercentageWithinForm')),
        config: {},
    },
};

export default DynamicSegmentForms;
